export default __webpack_public_path__ + "static/media/person.8be18edc.png";